import { render, staticRenderFns } from "./newReserve.vue?vue&type=template&id=475c7320&scoped=true&"
import script from "./newReserve.vue?vue&type=script&lang=js&"
export * from "./newReserve.vue?vue&type=script&lang=js&"
import style0 from "./newReserve.vue?vue&type=style&index=0&id=475c7320&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475c7320",
  null
  
)

export default component.exports